// This file was automatically generated from tourguide.supportGuideSplash.html.
// Please don't edit this file by hand.

goog.provide('el8.template.tourguide.supportGuideSplash');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.supportGuideSplash.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="tourGuideDialogContainer"><img class="fr" src="/static/images/icon_support_80x46.png"><h2>We\'re always here for you</h2><div class="tourGuideTextContainerSm mt1"><p class="el8FFF">No matter where you are in our application, you can always contact us directly by clicking the "I need help" menu at the top of the page. If your message is urgent, subscribers can also send us urgent feedback to receive a response within 30 minutes.</p><p class="el8FFF">Or, visit our Help Center in the "I need help" menu above.</p><div class="tourSplashButtonContainer"><a class="end-trigger tourGuideButton">Finish</a></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.supportGuideSplash.pointers = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="help-pointer"><img src="/static/images/arrow_topright.png"></div>');
  if (!opt_sb) return output.toString();
};
